const master = {
  '--primary': '#1c2939',
  '--secondary': '#dde5ed',
  '--tertiary': '',
};
export default master;
